import React, { useContext } from "react";

import Input from "@stadium/ui/src/components/input/input";
import { CurrentDeviceContext } from "@stadium/ui/src/contexts/responsive-content";

import SearchTemplateModal from "@components/modals/search-template";

import { useModal } from "@stadium/hooks/lib/use-modal";
import { usePageNameContext } from "@stadium/shared/page-name-provider";

import { SEARCH_TEMPLATES } from "@constants/modal-types";
import { MOMENTS } from "@constants/routes";

import styles from "./purge-main.module.scss";
import modalStyle from "@styles/shared/modal.module.scss";

const SearchInput = ({ onTemplateSelect = () => {} }) => {
  const { openModal, renderModal } = useModal(SEARCH_TEMPLATES, SearchTemplateModal);
  const { isMobileDevice } = useContext(CurrentDeviceContext);
  const pageName = usePageNameContext();

  return (
    <>
      <div className={styles.sideBarSearchBlock}>
        {!isMobileDevice && (
          <Input
            customClass={styles.searchInput}
            value={`Search all ${pageName === MOMENTS ? "moments" : "templates"}`}
            onClick={openModal}
            readOnly
          />
        )}
        <span className={styles.searchIcon} onClick={openModal} />
      </div>
      {renderModal({
        classes: {
          rootClass: modalStyle["primaryModal"],
          dialogClass: `${modalStyle["modalDialog"]} ${styles.searchModal}`,
        },
        data: {
          onTemplateSelect,
        },
      }, false,
      )}
    </>
  );
};

export default SearchInput;
